import { useApplicationUserContext } from 'context/ApplicationUser';

export default function useIndustryMinimumTopupLeads() {
    const { user } = useApplicationUserContext();

    return {
        industryMinTopupLeads: user?.minimumTopupLeads,
    };
}
